export default [
  {
    path: '/admin/pos/customer-restaurant-orders',
    name: 'customer-restaurant-order',
    meta: { requiresAuth: true },
    component: () => import('@/pages/restaurant-order/customer-order.vue')
  }
]
